import { PreAuthMaintenanceData } from "../../hooks/usePreAuthMaintenance";

interface LegacyMaintenanceData {
  title?: string;
  subtext?: string;
}

export interface MaintenanceProps {
  title: string;
  subtext: string;
  icon?: PreAuthMaintenanceData["icon"];
}

export const getMaintenanceProps = (
  preAuthMaintenance: PreAuthMaintenanceData | undefined,
  legacyMaintenanceData: LegacyMaintenanceData | undefined
): MaintenanceProps => ({
  title:
    preAuthMaintenance?.title ||
    legacyMaintenanceData?.title ||
    "Please try again soon",
  subtext:
    preAuthMaintenance?.subtext ||
    legacyMaintenanceData?.subtext ||
    "Service currently unavailable due to scheduled maintenance.",
  icon: preAuthMaintenance?.icon,
});
